import { createSlice } from '@reduxjs/toolkit';

export const startupValorationSlice = createSlice({
    name: 'startupValoration',
    initialState: {
        dataToAction: { startupId: '', participationValuation: '', valuationDate: '', startupName: ''}
    },
    reducers: {
        selectValorationStartup: (state, {payload}) => {
            state.dataToAction = payload;
        },
        unSelectValorationStartup: (state) => {
            state.dataToAction = { startupId: '', participationValuation: '', valuationDate: '', startupName: ''}
        }
    }
});

export const { selectValorationStartup, unSelectValorationStartup } = startupValorationSlice.actions;